import { useRoutes } from 'react-router-dom';
import { IRoutes, routes } from './routes';
import { useAppStore } from '@/store';
import { useMemo } from 'react';

const RouterInterceptor = () => {
  const {
    chainInfo: { path },
  } = useAppStore();

  // useEffect(() => {
  //   const currentPath = location.pathname;
  //   const pathSegments = currentPath.split('/').filter(Boolean);

  //   if (pathSegments.length > 0) {
  //     if (pathSegments.length > 1 && pathSegments[1] === 'trade') {
  //       const tokenAddress = chainTokenAddressMap[path];
  //       navigate(`/${path}/trade/${tokenAddress}${location.search}`);
  //     } else {
  //       const routeWithoutChain = pathSegments.slice(1).join('/');
  //       if (routeWithoutChain) {
  //         navigate(`/${path}/${routeWithoutChain}${location.search}`);
  //       } else {
  //         navigate(`/${path}/token/signal${location.search}`);
  //       }
  //     }
  //   }
  // }, [path, location.search, chainTokenAddressMap]);

  const genRoutes = (routes: IRoutes[]): IRoutes[] => {
    return routes.map((route) => {
      const newRoute = { ...route };
      if (newRoute.path && newRoute.path !== '/' && newRoute.path !== '*') {
        newRoute.path = '/' + path + newRoute.path;
      }
      if (newRoute.children && newRoute.children.length > 0) {
        newRoute.children = genRoutes(newRoute.children);
      }
      return newRoute;
    });
  };

  const initRoutes = useMemo(() => genRoutes([...routes]), [path]);
  const routeElements = useRoutes(initRoutes);

  return routeElements;
};

export { RouterInterceptor };
